import React from 'react';
import { rightsData } from '../data/rightsData';

export default function RightsInfo({ gradFinal }) {
  if (!gradFinal || gradFinal === 'Nespecificat' || gradFinal === 'Ușor') return null;

  const isGrav = gradFinal.includes('Grav');
  const isAccentuat = gradFinal === 'Accentuat';
  const isMediu = gradFinal === 'Mediu';

  // Determine which categories apply
  const categoriesToDisplay = [];
  
  if (isMediu || isAccentuat || isGrav) {
    categoriesToDisplay.push({ id: 'medical', label: 'Sănătate & Dispozitive Medicale', icon: '🩺', data: rightsData.medical });
    categoriesToDisplay.push({ id: 'educatie', label: 'Educație & Pensii', icon: '🎓', data: rightsData.educatie });
    categoriesToDisplay.push({ id: 'munca', label: 'Muncă & Angajare', icon: '💼', data: rightsData.munca });
    categoriesToDisplay.push({ id: 'altele', label: 'Drepturi Sociale & Juridice', icon: '⚖️', data: rightsData.altele });
    categoriesToDisplay.push({ id: 'modificari', label: 'Noutăți Legislative', icon: '🔔', data: rightsData.modificari });
  }

  if (isAccentuat || isGrav) {
    categoriesToDisplay.push({ id: 'transport', label: 'Transport & Mobilitate', icon: '🚌', data: rightsData.transport });
    categoriesToDisplay.push({ id: 'taxe', label: 'Scutiri Fiscale & Impozite', icon: '📉', data: rightsData.taxe });
    categoriesToDisplay.push({ id: 'utilitati', label: 'Utilități (TV/Radio)', icon: '📺', data: rightsData.utilitati });
  }

  if (isGrav) {
    categoriesToDisplay.push({ id: 'grav', label: 'Asistent Personal', icon: '🧑‍⚕️', data: rightsData.grav });
  }

  // Define some colors for UI flair
  const uiColors = {
    medical: '#38b2ac', // Teal
    educatie: '#805ad5', // Purple
    munca: '#dd6b20', // Orange
    altele: '#3182ce', // Blue
    modificari: '#e53e3e', // Red
    transport: '#e53e3e', // Red (already taken maybe another)
    taxe: '#d69e2e', // Yellow
    utilitati: '#00b5d8', // Cyan
    grav: '#d53f8c' // Pink
  };

  const renderArticle = (art, index) => (
    <div key={index} style={{
      background: '#fff',
      borderLeft: `4px solid ${art.isNew ? '#e53e3e' : '#3182ce'}`,
      boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
      padding: '16px',
      marginBottom: '16px',
      borderRadius: '8px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#2d3748', flex: 1 }}>{art.title}</h4>
        {art.isNew && <span style={{ background: '#e53e3e', color: '#fff', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 'bold' }}>NOU</span>}
      </div>
      
      <p style={{ margin: '0 0 12px 0', color: '#4a5568', whiteSpace: 'pre-line' }}>{art.body}</p>

      {art.steps && art.steps.length > 0 && (
        <div style={{ background: '#ebf8ff', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #3182ce', marginTop: '12px' }}>
          <strong style={{ color: '#2b6cb0', display: 'block', marginBottom: '8px', fontSize: '0.9rem' }}>PROCEDURĂ PAS CU PAS:</strong>
          <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.9rem', color: '#2c5282' }}>
            {art.steps.map((s, i) => <li key={i} style={{ marginBottom: '4px' }}>{s}</li>)}
          </ul>
        </div>
      )}

      {art.tips && (
        <div style={{ background: '#fffff0', padding: '12px', borderRadius: '6px', border: '1px solid #fefcbf', marginTop: '12px' }}>
          <span style={{ fontSize: '0.9rem', color: '#b7791f' }}>
            <strong>💡 Sfat Practic: </strong> {art.tips}
          </span>
        </div>
      )}
    </div>
  );

  return (
    <div style={{
      marginTop: '24px',
      background: '#f7fafc',
      padding: '24px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0'
    }} className="no-print">
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <h3 style={{ margin: '0 0 8px 0', color: '#2a4365', fontSize: '1.4rem' }}>
          Drepturi și Facilități (Legea 448/2006)
        </h3>
        <p style={{ margin: 0, color: '#4a5568' }}>
          Pentru încadrarea estimată: <strong style={{ color: '#2c5282', padding: '4px 8px', background: '#ebf8ff', borderRadius: '4px' }}>Handicap {gradFinal}</strong>
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {categoriesToDisplay.map((cat) => (
          <div key={cat.id} style={{ display: 'flex', flexDirection: 'column' }}>
            <h4 style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              color: '#2d3748', 
              borderBottom: `2px solid ${uiColors[cat.id] || '#e2e8f0'}`, 
              paddingBottom: '8px',
              marginBottom: '16px'
            }}>
              <span>{cat.icon}</span>
              {cat.label}
            </h4>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {cat.data.map((art, idx) => renderArticle(art, idx))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
